var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass: "d-flex flex-row align-items-center",
                    attrs: { cols: "12" },
                  },
                  [
                    _c("p", { staticClass: "text-primary bold mb-0" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.extractNameFromValue(_vm.collaborator)) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "pretty pb-1 p-switch p-fill ml-4",
                        staticStyle: { "font-size": "0.875rem" },
                      },
                      [
                        _c("input", {
                          attrs: { id: _vm.labelValue, type: "checkbox" },
                          domProps: { checked: _vm.value.to },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "d-none",
                            attrs: { for: _vm.labelValue },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("email.customFieldsTags.LABEL"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "state" }, [
                          _c(
                            "label",
                            { staticStyle: { "font-size": "0.9rem" } },
                            [
                              _c("span", { staticClass: "d-none" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("email.customFieldsTags.LABEL"))
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "overlay" }),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "b-row",
              {
                staticClass: "justify-content-between align-items-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c("i18n", {
                  staticClass: "mb-0",
                  attrs: {
                    path: "client-profile.changelog.changeEmailTrackingIndividual",
                    tag: "p",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "name",
                      fn: function () {
                        return [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getChangelogName(_vm.userDetails)) +
                                "\n          "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tiny-f mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatDateHour")(_vm.insertionTimestamp)) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }